import React from "react";
import {
  CountryAllocation,
  IndustriesAllocation,
  SectorAllocationTblLeft,
} from "../components";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

export const Allocations = () => {
  return (
    <div>
      <div className="header">
        <h1 className="header-title">Allocations </h1>
      </div>

      <div className="row">
        <Tabs>
          <TabList>
            <Tab>Sector</Tab>
            <Tab>Industries</Tab>
            <Tab>Country</Tab>
          </TabList>

          <TabPanel>
            <div className="col-12 col-md-12 col-xxl-12 d-flex">
              <SectorAllocationTblLeft chartTitle="Sector Allocation" />
            </div>
          </TabPanel>
          <TabPanel>
            <div className="col-12 col-md-12 col-xxl-12 d-flex">
              <IndustriesAllocation chartTitle="Industries Allocation" />
            </div>
          </TabPanel>
          <TabPanel>
            <div className="col-12 col-md-12 col-xxl-12 d-flex">
              <CountryAllocation chartTitle="Country Allocation" />
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};
